// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"86ec55ab","794":"d2956c02"}[chunkId] + ".chunk.css";
};